import { connect } from "react-redux";
import ChangeAssignee from "./changeAssignee";
import { bindActionCreators } from "redux";
import {
    getAssigneeList,
    postAssignee
} from "services/redux/brandActivtion/sitesListing/action";
import {newAssignee} from "../../../services/redux/BulkAssignment/action";

const mapStateToProps = (state) => ({
    assigneeList: state.baSiteListingReducer.assigneeList,
    newAssigneeRes: state.bulkAssignmentReducer.newAssigneeRes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAssigneeList,
            postAssignee,
            newAssignee
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAssignee);
